<!-- 自然拼读 听录音选字母成句 -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" :rules="rules" label-width="120px">

    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item label="">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>
      <el-form-item :label="'学习内容' + (index + 1)">
        <el-input v-model="item.wordName" disabled style="width: 500px;" />
      </el-form-item>
      <el-form-item
        v-if="item.state === 1"
        label="问题句型"
        :prop="'dataList.' + index + '.sentence'"
        :rules="rules.sentence"
      >
        <el-input v-model="item.sentence" placeholder="请输入包含学习内容的句子" style="width: 350px;" />
      </el-form-item>
      <el-form-item v-if="item.state === 1" label="音频" :prop="'dataList.' + index + '.voice'" :rules="rules.voice">
        <themeUploadList style="width: 350px;" code="customVoice" :file-list.sync="item.voice" accept=".mp3,.wmv" :limit="1" tip="仅支持.mp3文件" />
      </el-form-item>
      <el-form-item v-if="item.state === 1" label="资料库干扰项" :prop="'dataList.' + index + '.interfereIds'">
        <el-select v-model="item.interfereIds" placeholder="请选择" clearable filterable style="width: 500px;">
          <el-option v-for="item2 in interferenceListOptions(item)" :key="item2.id" :label="item2.name" :value="item2.id" :disabled="isOptionsDisable(item, item2)" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="item.state === 1" label="自定义干扰项">
        <el-button type="success" size="small" :disabled="item.interfereCardList.length >= 1" @click="addCustomerInterfereCard(index)">添加干扰项</el-button>
        <br>
        <div v-for="(item3, index3) in item.interfereCardList" :key="index3" class="interfereCard">
          <div class="cont">
            <el-form-item label="内容" label-width="60px" style="margin-bottom: 10px;">
              <el-input v-model="item3.wordName" maxlength="20" placeholder="请输入单词/字母名称" />
            </el-form-item>
            <el-form-item label="卡片图" label-width="60px">
              <themeUploadAvatar code="customImg" :file-list.sync="item3.imgFile" />
            </el-form-item>
          </div>
          <el-button type="warning" size="small" @click="deleteCustomerInterfereCard(index, index3)">删除</el-button>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import _ from 'lodash'
import themeUploadAvatar from '../../components/themeUploadAvatar'
import { mapState } from 'vuex'
import themeUploadList from '../../components/themeUploadList'
// import uploadList from '@/components/Upload/uploadList.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    themeUploadList,
    themeUploadAvatar
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    interferenceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList2: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        optionNum: 2,
        dataList: []
      },
      rules: {
        optionNum: [{ required: true, message: '请选择选项数量', trigger: 'change' }],
        interfereIds: [{ required: false, message: '请选择干扰项', trigger: 'change' }],
        sentence: [{ required: true, message: '请输入', trigger: 'blur' }],
        voice: [{ type: 'array', required: true, message: '请上传音频', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []

      this.gameList.forEach((item, index) => {
        const name = item.questionMeans ? item.questionMeans.pronunciationName : ''
        const fileName = item.questionMeans ? item.questionMeans.pronunciationFileName : ''
        const paramsUrl = item.questionMeans ? item.questionMeans.pronunciationPath : ''
        const voice = item.questionMeans ? [{ name: fileName, paramsFileName: name, paramsUrl: paramsUrl, url: paramsUrl }] : []
        const sentence = item.questionMeans ? item.questionMeans.wordName : ''

        this.interferenceForm.dataList.push({ state: item.state, studyId: item.studyId, wordName: item.wordName, interfereIds: item.interfereIdList.toString() ? Number(item.interfereIdList.toString()) : '', meansType: item.meansType, questionMeans: {}, voice: voice, sentence: sentence, interfereCardList: [] })

        const interfereCardList = item.interfereCustomMeans ? item.interfereCustomMeans : []
        for (const item2 of interfereCardList) {
          this.interferenceForm.dataList[index].interfereCardList.push({ wordName: item2.wordName, imgFile: [{ name: item2.cardChartName, paramsFileName: item2.cardChartName, paramsUrl: item2.cardChartPath, url: item2.cardChartRootPath }] })
        }
        // this.$set(this.interferenceForm.dataList[index], 'interfereCardList', interfereCardList)
      })

      // for (const item of this.gameList) {
      //   const name = item.questionMeans ? item.questionMeans.pronunciationName : ''
      //   const fileName = item.questionMeans ? item.questionMeans.pronunciationFileName : ''
      //   const paramsUrl = item.questionMeans ? item.questionMeans.pronunciationPath : ''
      //   const voice = item.questionMeans ? [{ name: fileName, paramsFileName: name, paramsUrl: paramsUrl, url: paramsUrl }] : []
      //   const sentence = item.questionMeans ? item.questionMeans.wordName : ''

      //   const interfereCardList = item.interfereCustomMeans ? item.interfereCustomMeans : []
      //   for (const item2 of interfereCardList) {
      //     item2.imgFile = [{ name: item2.cardChartName, paramsFileName: item2.cardChartName, paramsUrl: item2.cardChartPath, url: item2.cardChartRootPath }]
      //   }

      //   this.interferenceForm.dataList.push({ state: item.state, studyId: item.studyId, wordName: item.wordName, interfereIds: item.interfereIdList.toString() ? Number(item.interfereIdList.toString()) : '', meansType: item.meansType, questionMeans: {}, voice: voice, sentence: sentence, interfereCardList: interfereCardList })
      // }
    }
  },
  created () {

  },
  methods: {
    // 根据游戏类型 和 meansType 判断 干扰项取值
    interferenceListOptions (item) {
      // if (this.currentQuizType === '4003') {
      //   return this.interferenceList
      // } else if (this.currentQuizType === '2002') {
      //   return this.interferenceList
      // } else if (item.meansType === '1') {
      //   return this.interferenceList
      // } else {
      //   return this.interferenceList2
      // }

      // 自然拼读 的句型 放到第二个干扰项选项
      if (this.currentQuizType === '4003') {
        return this.interferenceList
      } else {
        if (item.meansType === '4') {
          return this.interferenceList2
        } else {
          return this.interferenceList
        }
      }
    },
    isOptionsDisable (item, item2) {
      let flag = false
      if (this.currentQuizType === '2002' || this.currentQuizType === '4003') {
        if (item.parentId === item2.id) {
          console.log(999)
          flag = true
        } else {
          flag = false
        }
      } else {
        if (item.studyId === item2.id) {
          flag = true
        } else {
          flag = false
        }
      }
      return flag
    },
    getWordsBySentence (sentence) {
      const sentenceStr = sentence.replace(/[|\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, ' ')
      let words = sentenceStr.split(' ')
      words = words.filter(item => {
        return item
      })
      return words
    },
    addCustomerInterfereCard (index) {
      this.interferenceForm.dataList[index].interfereCardList.push({ wordName: '', imgFile: [] })
    },
    deleteCustomerInterfereCard (index, index3) {
      this.$confirm('是否确认删除干扰项?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.interferenceForm.dataList[index].interfereCardList.splice(index3, 1)
      })
    },
    // 验证干扰项 选择必填项
    isValidateOptions () {
      let flag = false
      const arr = _.cloneDeep(this.interferenceForm.dataList)
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].state === 0) {
          continue
        }
        for (var j = 0; j < arr[i].interfereCardList.length; j++) {
          if (arr[i].interfereCardList[j].wordName === '' || arr[i].interfereCardList[j].imgFile.length === 0) {
            this.$message.error(`学习内容${i + 1}自定义干扰项信息未填写完整`)
            flag = true
            return flag
          }
        }

        // 判断 输入的句子 是否包含 字母
        const formatStr = this.getWordsBySentence(arr[i].sentence)
        if (!formatStr.includes(arr[i].wordName)) {
          this.$message.error(`学习内容${i + 1}输入的句型未包含对应的字母`)
          flag = true
          return flag
        }

        if (arr[i].interfereIds && arr[i].interfereCardList.length === 1) {
          this.$message.error(`学习内容${i + 1}资料库干扰项与自定义干扰项必须只能选其一`)
          flag = true
          return flag
        } else if (!arr[i].interfereIds && arr[i].interfereCardList.length === 0) {
          this.$message.error(`学习内容${i + 1}资料库干扰项与自定义干扰项必须选其一`)
          flag = true
          return flag
        }
      }
      return flag
    },
    // 保存游戏配置项
    saveGameOptions() {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        const arr = _.cloneDeep(this.interferenceForm.dataList)
        let checkTotal = 0
        for (var i = 0; i < arr.length; i++) {
          checkTotal = checkTotal + arr[i].state
        }
        if (checkTotal === 0) {
          this.$message.error(`请至少选中一条学习内容`)
          return false
        }

        if (this.isValidateOptions()) {
          return false
        }

        // 下拉框为单选, 传参格式 改为数组
        for (const item of arr) {
          item.interfereIds = item.interfereIds ? [item.interfereIds] : []

          if (item.state === 1) {
            item.questionMeans.pronunciationName = item.voice[0].paramsFileName
            item.questionMeans.pronunciationPath = item.voice[0].paramsUrl
            item.questionMeans.wordName = item.sentence
          } else {
            item.questionMeans = null
          }

          item.interfereCustomMeans = item.interfereCardList
          for (const item2 of item.interfereCustomMeans) {
            item2.cardChartName = item.state === 1 ? item2.imgFile[0].paramsFileName : ''
            item2.cardChartPath = item.state === 1 ? item2.imgFile[0].paramsUrl : ''
          }
        }
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          items: arr
        }
        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>

</style>
